import { render, staticRenderFns } from "./DonationTypes.vue?vue&type=template&id=1c2294da&"
import script from "./DonationTypes.vue?vue&type=script&lang=js&"
export * from "./DonationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports